export enum RefundStatusMessageCode {
    // Received Message
    RECEIVED = 'RECEIVED',
    // Showing FOP Details Messages
    AA = 'AA',
    AX = 'AX',
    DC = 'DC',
    DS = 'DS',
    JC = 'JC',
    MC = 'MC',
    VI = 'VI',
    UATP = 'UATP',
    // Original FOP Messages
    ORIGINAL_FOP = 'ORIGINAL_FOP',
    PP = 'PP',
    WC = 'WC',
    CU = 'CU',
    AL = 'AL',
    // Non CC FOP Messages
    VC = 'VC',
    GC = 'GC',
    CM = 'CM',
    CK = 'CK',
    IC = 'IC',
    // Denied Messages
    NRD = 'NRD',
    NRBE = 'NRBE',
    FEES = 'FEES',
    WAIV = 'WAIV',
    FARU = 'FARU',
    RREZ = 'RREZ',
    VIAS = 'VIAS',
    GOGO = 'GOGO',
    VFOP = 'VFOP',
    NRBR = 'NRBR',
    WVBR = 'WVBR',
    ATQU = 'ATQU',
    MEDD = 'MEDD',
    NCCS = 'NCCS',
    USED = 'USED',
    PANA = 'PANA',
    RADV = 'RADV',
    REAC = 'REAC',
    EXPR = 'EXPR',
    NRTC = 'NRTC',
    DNLC = 'DNLC'
}
